import * as React from 'react'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'
import Button from '../../../../../components/button'
import styles from './section-five.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: `Din personliga senior ekonom + AI står redo för dig. 
Välkommen till framtiden.`,
    id: 'consultant.section-five.heading',
  },
  button: {
    defaultMessage: 'Få en offert',
    id: 'consultant.section-five.button',
  },
})

export default function SectionFive() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <FormattedHTMLMessage tagName="h2" {...messages.heading} />
        <Button href="/signup" variant="success">
          <FormattedHTMLMessage {...messages.button} />
        </Button>
      </div>
    </div>
  )
}
